import { COMPANY_TYPES } from "../../../constants";
const currentYear = new Date().getFullYear();
const initial = {
  year: currentYear,
  type: COMPANY_TYPES[1].value,
  startMonth: 1,
  endMonth: 12,
};
const chartFilterReducer = (state = initial, action) => {
  switch (action.type) {
    case "CF_GET":
      return { ...state };
    case "CF_TYPE":
      return {
        ...state,
        type: action.data,
      };
    case "CF_YEAR":
      return {
        ...state,
        year: action.data,
      };
    case "CF_PERIOD":
      /*
      1 => 1
      2 => 4
      3 => 7
      4 => 10
       */
      const period = action.data;
      const startMonth = (period - 1) * 2 + period * 1;
      const endMonth = startMonth + 2;
      return {
        ...state,
        period: action.data,
        startMonth: startMonth,
        endMonth: endMonth,
      };
    case "CF_MONTH_START":
      return {
        ...state,
        startMonth: action.data,
      };
    case "CF_MONTH_END":
      return {
        ...state,
        endMonth: action.data,
      };
    default:
      return state;
  }
};

export default chartFilterReducer;
